// Читает ?token=... один раз и сразу убирает его из адресной строки,
// чтобы токен не оставался в истории браузера
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function useUrlToken() {
  const location = useLocation();
  const [token] = useState(() => new URLSearchParams(location.search).get('token') || '');

  useEffect(() => {
    window.history.replaceState(window.history.state, '', window.location.pathname);
  }, []);

  return token;
}
